import axios from "axios";
import { Chart } from "devextreme-react";
import {
  ArgumentAxis,
  Border,
  CommonSeriesSettings,
  Export,
  Legend,
  Margin,
  Point,
  Series,
  Tooltip,
} from "devextreme-react/chart";
import React, { useEffect, useState } from "react";
import { CLINIC_STEP_NAMEList } from "./data";

export default function CumulativeDistributionByYear(props) {
  const { indication, palette } = props;
  const [dataSource, setDataSource] = useState(null);

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/mdcinClincTestInfoService01/YEAR/CLINIC_STEP_NAME?indication=${indication}`
      )
      .then((result) => {
        setDataSource(result.data);
      });
  }, [indication]);

  const customizeTooltip = (arg) => {
    return {
      text: `${arg.seriesName}: ${Number(arg.valueText).toLocaleString()}`,
    };
  };

  return (
    <React.Fragment>
      <Chart title={"Status by Year"} dataSource={dataSource} palette={palette}>
        <CommonSeriesSettings argumentField={"YEAR"} type={"steparea"}>
          {/* <Border visible={false} /> */}
          <Point visible={true} />
        </CommonSeriesSettings>
        {CLINIC_STEP_NAMEList.map((csn, index) => {
          return <Series key={csn} valueField={csn} name={csn} />;
        })}
        <Margin bottom={20} />
        <ArgumentAxis valueMarginsEnabled={false} />
        <Legend verticalAlignment={"bottom"} horizontalAlignment={"center"} />
        <Export enabled={true} />
        <Tooltip
          enabled={true}
          location={"center"}
          customizeTooltip={customizeTooltip}
        />
      </Chart>
    </React.Fragment>
  );
}
